import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage loading state based on data availability
 * Automatically sets loading to false when data is available
 *
 * @param data - The data to watch for changes
 * @returns Tuple of [loading state, setLoading function]
 *
 * @example
 * const contentData = useAppSelector((state) => state.admin.contentData);
 * const [loading, setLoading] = useDataLoading(contentData);
 */
export function useDataLoading<T>(data: T | null | undefined): [boolean, (loading: boolean) => void] {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (data !== null && data !== undefined) {
      setLoading(false);
    }
  }, [data]);

  const setLoadingState = useCallback((newLoading: boolean) => {
    setLoading(newLoading);
  }, []);

  return [loading, setLoadingState];
}

export default useDataLoading;
